import { MyField } from "../../components/types";
import { FunctionField, NumberField } from "react-admin";
import { base, BaseArgs } from "./base";
import { format, parse } from "../percent";
import get from "lodash/get";
export interface PercentArgs extends BaseArgs {}

const defaultArgs: Partial<PercentArgs> = {
  isRequired: false,
  fullWidth: false,
};

export function percent(args: PercentArgs, field?: MyField) {
  return base(
    {
      ...defaultArgs,
      ...args,
    },
    {
      component: FunctionField,
      isFilter: false,
      sortable: false,
      isEdit: false,
      isUpdate: false,
      props: {
        textAlign: "right",
        render: (record: any, source: string) =>
          format(get(record, source as string)),
      },
    },
    field
  );
}
